/* eslint-disable @typescript-eslint/camelcase */
import { httpClient } from "@/shared/services/http-client";
import { useStore } from "vuex";
import { loadingService } from "../services/loading-service";
import { msalInstance } from "@/shared/services/auth-config";
function parseJwt(token: any) {
  const base64Url = token.split(".")[1];
  const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
  const jsonPayload = decodeURIComponent(
    atob(base64)
      .split("")
      .map(function (c) {
        return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
      })
      .join("")
  );

  return JSON.parse(jsonPayload);
}

function populateInitial(firstName: string, lastName: string) {
  // let initial = ''

  // if (firstName && lastName) {
  //   if (firstName !== '') {
  //     initial += firstName.charAt(0).toUpperCase()
  //   }
  //   if (lastName !== '') {
  //     initial += lastName.charAt(0).toUpperCase()
  //   }
  // }
  return `${firstName} ${lastName}`; //initial
}
const store = useStore();
export const userState = {
  namespaced: true,
  state: {
    auth: null,
    authenticated: false,
    jwt: null,
    firstName: "",
    lastName: "",
    specialPermissionList: [],
    permissionList: {},
    isFindex: false,
    isFindexAll: false,
    isSuperUser: true,
    entityLookUpList: [],
    lastSelectedEntity: {},
    selectedEntity: {},
    showPermissionDeniedMessage: false
  },
  getters: {
    getUserInitial: (state: { firstName: string; lastName: string }) => {
      return populateInitial(state.firstName, state.lastName);
    },
    getSelectedEntity: (state: { selectedEntity: any }) => state.selectedEntity
  },
  mutations: {
    setAuthenticated(
      state: { jwt: any; authenticated: boolean },
      token: { accessToken: any }
    ) {
      state.jwt = token.accessToken;
      state.authenticated = true;
    },
    clearAuthentication(state: { authenticated: boolean; jwt: any }) {
      state.authenticated = false;
      state.jwt = null;
    },
    setUserAuthData(state: any, data: any) {
      state.authenticated = true;
      state.jwt = data.accessToken;
      state.firstName =
        data.account.idTokenClaims.given_name ||
        data.account.idTokenClaims.name;
      state.lastName = data.account.idTokenClaims.family_name;
      state.testingIfDataPassedfromLanding = true;
      state.checkifAuthenticatedisTrue = state.authenticated ? true : false;
    },
    setUserData(state: any, data: any) {
      state.specialPermissionList = data.specialPermissionList;
      state.permissionList = data.permissionList;
      state.entityLookUpList = data.entityLookUpList;
      state.isSuperUser = data.isSuperUser;
      state.isFindex = data.isFindex;
      state.isFindexAll = data.isFindexAll;
      state.lastSelectedEntity = data.lastSelectedEntity;
    },
    setSelectedEntity(state: { selectedEntity: any }, data: any) {
      state.selectedEntity = data;
    },
    setShowPermissionDeniedMessage(state: any, data: any) {
      state.showPermissionDeniedMessage = true;
    },
    setShowPermissionDeniedMessageInternal(state: any, data: any) {
      if (JSON.parse(JSON.stringify(data.specialPermissionList)).length === 0) {
        state.showPermissionDeniedMessage = true;
      } else if (JSON.parse(JSON.stringify(data.permissionList)).length === 0) {
        state.showPermissionDeniedMessage = true;
      } else {
        state.showPermissionDeniedMessage = false;
      }
    },
    setLastSelectedEntity(state: { lastSelectedEntity: any }, data: any) {
      state.lastSelectedEntity = data;
    },
    setEntityLookUpList(state: { entityLookUpList: any }, data: any) {
      state.entityLookUpList = data;
    }
  },
  actions: {
    authenticate(context: any, token: any) {
      if (token) {
        const userData: any = {};
        // userData.firstName = ""
        // userData.lastName = ""
        userData.jwt = token;
        userData.authenticated = true;
      }
      sessionStorage.setItem("user", "");
    },
    async logout(context: any) {
      context.commit("clearAuthentication");
      msalInstance.logoutPopup();
      context.commit("setShowPermissionDeniedMessage");
      sessionStorage.removeItem("user");
    },
    init(context: any) {
      const data = sessionStorage.getItem("user");
      if (data) {
        const userData = JSON.parse(data);
        if (userData.jwt) {
          const tokenInfo = parseJwt(userData.jwt);
          userData.firstName = tokenInfo.given_name;
          userData.lastName = tokenInfo.family_name;
        }
        context.commit("setUserAuthData", userData);
        context.dispatch("retrieveUserDetail");
      }
    },
    setShowPermissionDeniedMessage(context: any) {
      context.commit("setShowPermissionDeniedMessage", true);
    },
    async retrieveUserDetail(context: {
      commit: (arg0: string, arg1: any) => void;
      dispatch: (arg0: string, arg1: any) => void;
    }) {
      const url = `/users`;

      return await httpClient
        .get(url)
        .then((res) => {
          const data = res.data;
          const result = { success: true, errorMessage: "" };

          if (!data.message) {
            context.commit("setUserData", data);
            context.commit("setShowPermissionDeniedMessageInternal", data);
            //If user has last selected entity set, use it by default
            if (data.lastSelectedEntity) {
              context.commit("setSelectedEntity", data.lastSelectedEntity);
            } else {
              //Otherwise use first one from entity list
              if (data.entityLookUpList && data.entityLookUpList.length > 0) {
                context.dispatch(
                  "updateSelectedEntity",
                  data.entityLookUpList[0]
                );
              }
            }
          } else {
            result.success = false;
            result.errorMessage = "Error retrieve user detail";
          }
          return result;
        })
        .catch((err) => {
          throw err; // reject
        });
    },
    async updateSelectedEntity(context: any, entity: any) {
      if (entity) {
        context.commit("setSelectedEntity", entity);
        //now update database
        await httpClient
          .patch(`/users`, { last_selected_entity: entity.id })
          .then((res) => {
            const data = res.data;
            const result = { success: true, errorMessage: "" };

            if (!data.message) {
              if (data.lastSelectedEntity) {
                context.commit(
                  "setLastSelectedEntity",
                  data.lastSelectedEntity
                );
              }
            } else {
              result.success = false;
              result.errorMessage = "Error update selected entity";
            }
            return result;
          })
          .catch((err) => {
            throw err; // reject
          });
      }
    },
    async createEntity(context, params) {
      if (params) {
        alert("Show the Create ENtity ");
        console.log(params);
        // loadingService.showLoading(true);
        return await httpClient
          .post(`/entities`, params)
          .then((res) => {
            const data = res.data;
            const result = { success: true, errorMessage: "" };

            if (!data.message) {
              const newEntity = data.entity;
              if (newEntity) {
                const entityLookUpList = [...this.state.user.entityLookUpList];
                const existed = entityLookUpList.find(
                  (e) => e.id === newEntity.id
                );
                if (existed) {
                  //shouldn't happen
                  existed.entity_name = newEntity.entity_name;
                  existed.industry_name = newEntity.industry_name;
                } else {
                  entityLookUpList.push({
                    id: newEntity.id,
                    industry_name: newEntity.industry_name,
                    entity_name: newEntity.entity_name,
                    industry_id: newEntity.industry_id
                  });
                }
                context.commit("setEntityLookUpList", entityLookUpList);
              }
            } else {
              result.success = false;
              result.errorMessage = "Error create entity";
            }
            return result;
          })
          .catch((err) => {
            console.log(err);
            throw err; // reject
          })
          .finally(() => {
            // loadingService.showLoading(false);
          });
      }
    },
    async updateEntity(context: any, params: any) {
      if (params) {
        loadingService.showLoading(true);
        return await httpClient
          .patch(`/entities`, params)
          .then((res) => {
            const data = res.data;
            const result = { success: true, errorMessage: "" };

            if (!data.message) {
              const updatedEntity = data.entity;
              if (updatedEntity) {
                const entityLookUpList = [...this.state.user.entityLookUpList];
                const existed = entityLookUpList.find(
                  (e) => e.id === updatedEntity.id
                );
                if (existed) {
                  existed.entity_name = updatedEntity.entity_name;
                  existed.industry_name = updatedEntity.industry_name;
                  context.commit("setEntityLookUpList", entityLookUpList);
                  context.commit("setSelectedEntity", existed);
                }

                const adminEntityList = [
                  ...this.state.admin.adminEntityList.entities
                ];
                const existedEntity = adminEntityList.find(
                  (e) => e.id === updatedEntity.id
                );
                if (existedEntity) {
                  existedEntity.name = updatedEntity.entity_name;
                  store.dispatch(
                    "admin/updateAdminEntityList",
                    adminEntityList
                  );
                }
              }
            } else {
              result.success = false;
              result.errorMessage = "Error update entity";
            }
            return result;
          })
          .catch((err) => {
            console.log(err);
            throw err; // reject
          })
          .finally(() => {
            loadingService.showLoading(false);
          });
      }
    }
  }
};
